<template>
  <div style="min-height:100vh">
    <membership-banner
      :styles="$store.getters['membership'].style"
      :label="$store.getters['membership'].label"
    ></membership-banner>

    <section class="secondary white--text" id="step-banner">
      <v-container fluid>
        <v-row align="center">
          <v-col cols="1" md="2">
            <v-btn icon dark @click="step=1" v-if="step==2">
              <v-icon>fa-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="10" md="8" class="text-center">
            <transition
              mode="out-in"
              :name="step==1 ? 'slide-x-reverse-transition' : 'slide-x-transition'"
            >
              <h3 v-if="step==1">Choose Your Edit Service</h3>
              <h3 v-if="step==2">Customize Your Edit Request</h3>
            </transition>
          </v-col>
          <v-col cols="1" md="2"></v-col>
        </v-row>
      </v-container>
    </section>

    <transition mode="out-in" :name="step==1 ? 'slide-x-reverse-transition' : 'slide-x-transition'">
      <section id="edit-services" v-if="step==1">
        <v-container class="py-0">
          <v-row justify="center">
            <v-col cols="12" lg="12" xl="9">
              <v-container>
                <v-row justify="end">
                  <v-col cols="12" md="6" lg="4" xl="4" class="text-right">
                    <v-select
                      :items="['Event','Business']"
                      clearable
                      v-model="filter"
                      label="Filter By"
                      placeholder="Show all"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row :justify="$vuetify.breakpoint.name==='xs' ? 'center' : 'start'">
                  <v-col
                    cols="10"
                    sm="6"
                    md="4"
                    lg="4"
                    xl="4"
                    v-for="(item,i) in filteredServices"
                    :key="i"
                  >
                    <v-card>
                      <v-img :aspect-ratio="16/9" :src="item.preview.thumbnail">
                        <v-overlay absolute>
                          <v-btn
                            color="primary"
                            dark
                            @click="$eventBus.$emit('play_video',item.preview.url)"
                          >
                            <v-icon>fa-play</v-icon>
                          </v-btn>
                        </v-overlay>
                      </v-img>
                      <v-card-text class="mb-0">
                        <h3 class="secondary--text">{{item.title}}</h3>
                        <p class="mb-0">{{item.description}}</p>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          dark
                          :color="item.type==='Event' ? 'success' : 'blue'"
                          @click="selectService(item)"
                        >Explore</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <section id="customize-edit" v-if="step==2">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="6" lg="4" class="pb-0">
              <v-img :aspect-ratio="16/9" :src="selected_service.preview.thumbnail">
                <v-overlay absolute>
                  <v-btn
                    color="primary"
                    dark
                    @click="$eventBus.$emit('play_video',selected_service.preview.url)"
                  >
                    <v-icon>fa-play</v-icon>
                  </v-btn>
                </v-overlay>
              </v-img>
              <h1 class="text-center mt-4">{{selected_service.title}}</h1>
              <p class="text-center mb-0">{{selected_service.description}}</p>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12" md="10" lg="8" xl="6">
              <v-container class="pa-0">
                <v-row justify="center">
                  <v-col cols="12">
                    <v-treeview
                      open-all
                      dense
                      v-model="selected_applicants"
                      selectable
                      :items="treeItems"
                    ></v-treeview>
                  </v-col>
                  <v-col cols="12" class="text-center text-md-left">
                    <v-textarea
                      outlined
                      label="Notes for editor"
                      hide-details
                      v-model="edit_request.notes"
                    ></v-textarea>
                    <div class="mt-2">
                      <v-btn color="blue" class="mx-1 my-1" dark small>Upload alternate song</v-btn>
                      <v-btn color="blue" class="mx-1 my-1" dark small>Upload Alternate Logo</v-btn>
                    </div>
                  </v-col>
                  <v-col cols="7" md="6" class="text-right pr-0">
                    <h4 class="text--secondary">Approximate duration:</h4>
                    <h4 class="text--secondary">Price:</h4>
                  </v-col>
                  <v-col cols="5" md="6" class="text-left pl-2">
                    <h4>
                      <span
                        v-if="quote.duration>0"
                      >{{quote.duration > 60 ? (quote.duration/60).toFixed(1) : (quote.duration).toFixed(0)}} {{quote.duration > 60 ? 'minutes' : 'seconds'}}</span>
                      <span v-else>-</span>
                    </h4>
                    <h4>
                      <span v-if="quote.duration>0">${{quote.price}}</span>
                      <span v-else>-</span>
                    </h4>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn :dark="canBuy" color="green" :disabled="!canBuy">Buy now</v-btn>
                  </v-col>

                  <v-col cols="12" md="12" lg="8" xl="6" class="d-none">
                    <div class="d-flex">
                      <v-text-field
                        filled
                        label="Approximate Run Time"
                        :value="quote.duration > 60 ? (quote.duration/60).toFixed(1) : (quote.duration).toFixed(0)"
                        :suffix="quote.duration > 60 ? 'minutes' : 'seconds'"
                      ></v-text-field>
                      <v-text-field
                        class="ml-2"
                        filled
                        label="Price"
                        :value="quote.price"
                        prefix="$"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </transition>

    <div id="loading">
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="secondary" dark class="py-4 px-2">
          <v-progress-linear indeterminate color="primary" class></v-progress-linear>
        </v-card>
      </v-dialog>
    </div>
    <div id="portal-selection"></div>
    <div id="edit-request"></div>
  </div>
</template>

<script>
import membershipBanner from "@/components/user/membership_banner";
export default {
  name: "Editing",
  components: {
    membershipBanner
  },
  data() {
    return {
      filter: null,
      edit_request: {
        notes: ""
      },
      step: 1,
      loading: false,
      services: [],
      portal: null,
      applicants: [],
      selected_applicants: [],
      selected_service: null
    };
  },
  computed: {
    canBuy() {
      if (this.quote.duration === 0) {
        return false;
      }
      if (this.selected_applicants.length === 0) {
        return false;
      }
      return true;
    },
    quote() {
      let total = {
        price: parseInt(this.selected_service.price.base),
        duration: 0
      };
      this.filteredApplicants.forEach(
        function(applicant) {
          applicant.sections.forEach(
            function(section) {
              section.videos.files.forEach(file => {
                total.duration += file.duration;
                total.price +=
                  Math.ceil(file.duration / 60) *
                  this.selected_service.price.video;
              });
              section.photos.files.forEach(() => {
                total.duration += 3;
                total.price += this.selected_service.price.photo;
              });
              section.documents.files.forEach(() => {
                total.duration += 3;
                total.price += this.selected_service.price.document;
              });
            }.bind(this)
          );
        }.bind(this)
      );
      return total;
    },
    filteredApplicants() {
      return this.applicants.filter(
        function(applicant) {
          return this.selected_applicants.includes(applicant.uid);
        }.bind(this)
      );
    },
    treeItems() {
      return [
        {
          name: this.portal.name,
          id: "portal",
          children: [
            {
              name: "Applicants",
              id: "applicants",
              children: this.applicants.map(a => {
                return {
                  id: a.uid,
                  name: a.name
                };
              })
            }
          ]
        }
      ];
    },
    filteredServices() {
      return this.services.filter(
        function(i) {
          if (this.filter) {
            if (i.type === this.filter) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }.bind(this)
      );
    }
  },
  created() {
    this.load();
  },
  methods: {
    selectService(item) {
      this.selected_service = item;
      this.step = 2;
    },
    async load() {
      this.loading = true;
      try {
        await this.loadServices();
        await this.loadPortal(this.$route.params.id);
      } catch (ex) {
        alert(ex.error);
      }

      this.loading = false;
    },
    async loadPortal(id) {
      try {
        this.portal = await this.$api(`/user/portals/${id}`);
        this.applicants = await this.$api(
          `/user/portals/${this.portal.id}/applicants`
        );
        this.selected_applicants = this.applicants.map(a => {
          return a.uid;
        });
      } catch (ex) {
        alert(ex.error);
        this.$router.push("/portals");
      }
    },
    async loadServices() {
      this.services = await this.$api(`/edit-services`);
    }
  }
};
</script>

<style>
</style>